module.exports = __webpack_public_path__ + "static/media/sara.c1a90eac.jpg";